exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ies-actions td:first-child{\n    padding:0px;\n}\ninput:disabled {\n    background: #dddddd;\n}\ntable.sample {\n    border: solid 1px darkgray;\n}\ntable.sample tr td {\n    border: solid 1px darkgray;\n    padding: 1rem;\n}\n.is-invalid {\n    background-color: #FFBBBB;\n}\n.is-headings {\n    background-color: lightgray;\n}\n.is-not-relevant {\n    background-color: gray;\n}\n", ""]);

// exports
